import React from 'react';
import StatCardAtom, {
  StatCardAtomProps,
} from '../../atoms/StatCard/StatCardAtom';
import './StatCardRowMolecule.scss';

export type StatCardRowColumns = 1 | 2 | 3 | 4;

export interface StatCardRowMoleculeProps {
  /** Stat card definitions in display order. */
  stats: StatCardAtomProps[];
  /** Number of columns. Defaults to `stats.length` clamped to [1, 4]. */
  columns?: StatCardRowColumns;
  /** When true, the grid collapses to fewer columns at narrow viewports. */
  responsive?: boolean;
  /** Optional aria-label override applied to the row. */
  ariaLabel?: string;
  className?: string;
}

function clampColumns(value: number): StatCardRowColumns {
  if (value <= 1) return 1;
  if (value === 2) return 2;
  if (value === 3) return 3;
  return 4;
}

const StatCardRowMolecule: React.FC<StatCardRowMoleculeProps> = ({
  stats,
  columns,
  responsive = true,
  ariaLabel,
  className = '',
}) => {
  if (!stats || stats.length === 0) {
    return null;
  }

  const resolvedColumns: StatCardRowColumns =
    columns ?? clampColumns(stats.length);

  const classes = [
    'stat-card-row-molecule',
    `stat-card-row-molecule--cols-${resolvedColumns}`,
    responsive ? 'stat-card-row-molecule--responsive' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <ul className={classes} aria-label={ariaLabel}>
      {stats.map((stat, index) => (
        <li
          key={`${stat.label}-${index}`}
          className="stat-card-row-molecule__cell"
        >
          <StatCardAtom {...stat} />
        </li>
      ))}
    </ul>
  );
};

StatCardRowMolecule.displayName = 'StatCardRowMolecule';

export default StatCardRowMolecule;
